import { render } from "./BreadScrum.vue?vue&type=template&id=2fbcfb1a&scoped=true&ts=true"
import script from "./BreadScrum.vue?vue&type=script&lang=ts"
export * from "./BreadScrum.vue?vue&type=script&lang=ts"

import "./BreadScrum.vue?vue&type=style&index=0&id=2fbcfb1a&scoped=true&lang=scss"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbcfb1a"]])

export default __exports__